import React, { useState } from 'react';
import { Chip } from '@mui/material';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import { useAppSelector } from 'hooks/useAppSelector';
import PendingSpotsPanel from 'components/PendingSpotsPanel';

const PendingSpotsBanner = () => {
    const tokenData = useAppSelector((state) => state.auth.tokenData);
    const spots = useAppSelector((state) => state.pendingSpots.spots);
    const [panelOpen, setPanelOpen] = useState(false);

    if (!tokenData?.data?.superadmin || spots.length === 0) return null;

    return (
        <>
            <Chip
                label={`${spots.length} pending approval`}
                icon={<PendingActionsIcon />}
                onClick={() => setPanelOpen(true)}
                sx={{
                    'position': 'absolute',
                    'bottom': 64,
                    'left': '50%',
                    'transform': 'translateX(-50%)',
                    'zIndex': 10,
                    'cursor': 'pointer',
                    'fontWeight': 600,
                    'backgroundColor': 'error.main',
                    'color': 'error.contrastText',
                    '& .MuiChip-icon': { color: 'error.contrastText' },
                    '&:hover': { backgroundColor: 'error.dark' },
                }}
            />
            <PendingSpotsPanel open={panelOpen} onClose={() => setPanelOpen(false)} />
        </>
    );
};

export default PendingSpotsBanner;
